'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Layer, _React$Component);

  function Layer(props) {
    (0, _classCallCheck3.default)(this, Layer);
    return (0, _possibleConstructorReturn3.default)(this, (Layer.__proto__ || (0, _getPrototypeOf2.default)(Layer)).call(this, props));
  }

  (0, _createClass3.default)(Layer, [{
    key: 'render',
    value: function render() {
      var layer = this.props.layer;
      var url = '';

      if (layer.type == 'image') {
        url = this.context.baseUrl + "/media/image/" + layer.img;
      }
      var markup = layer.type === 'string' ? layer.txt : "<img draggable='false' src=" + url + " />";

      return _react2.default.createElement('span', { className: 'layer', 'data-depth': layer.velocity, dangerouslySetInnerHTML: { __html: markup } });
    }
  }]);
  return Layer;
}(_react2.default.Component), _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired
}, _temp);
exports.default = Layer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Parallax/Layer.js
// module id = 801
// module chunks = 0